import useFormatter from "@coworker/app/src/hooks/useFormatter";
import { ComponentNotificationFooter } from "./types/task-notification.types";
import styles from "./task-notification.module.css";
import { useTranslation } from "@coworker/locales";

interface TaskNotificationFooterDateAndTypeProps extends ComponentNotificationFooter {
  createdAt: string;
}
export const TaskNotificationFooterDateAndType = ({
  props: { taskLabel },
  createdAt,
}: TaskNotificationFooterDateAndTypeProps) => {
  const { t } = useTranslation();
  const { formatDateTimeShort } = useFormatter();

  return (
    <div className={styles["task-notification-item-footer"] ?? ""}>
      {!!taskLabel && (
        <>
          {t(taskLabel)}
          <span
            className={styles["task-notification-item-footer-bullet"] ?? ""}
          >
            &bull;
          </span>
        </>
      )}
      <span>{`${formatDateTimeShort(createdAt)}`}</span>
    </div>
  );
};
